import { useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "components/ui_new/index";
import { Spinner } from "components/ui";
import { respondToChatNotification } from "actions/chat";
import ConfirmationModal from "components/upcoming-chats/confirmation-modal";
import useTranslate from "hooks/use-translate-language";

const UnconfirmedAppointmentActions = ({
  chat_id,
  accepted,
  mobileCard = false
}) => {
  const translate = useTranslate();

  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  return accepted === null ? (
    <>
      {isSubmitting ? (
        <Spinner />
      ) : (
        <div className="appointment-actions-container">
          <ConfirmationModal
            title={"declineAppointmentSummary"}
            buttonText={"declineAppointmentActionText"}
            message={"declineAppointmentConfirmation"}
            onYes={async closeModal => {
              try {
                closeModal();
                setIsSubmitting(true);
                await dispatch(respondToChatNotification(chat_id, "decline"));
              } finally {
                setIsSubmitting(false);
              }
            }}
            spinner={isSubmitting}
            mobileCard={mobileCard}
          />

          <Button
            variant="contained"
            className={`${mobileCard ? "mobile-primary-button" : ""}`}
            color="primary"
            id="accept-button"
            onClick={async () => {
              try {
                setIsSubmitting(true);
                await dispatch(respondToChatNotification(chat_id, "accept"));
              } finally {
                setIsSubmitting(false);
              }
            }}
            style={{
              width: "100%",
              maxWidth: mobileCard ? "100%" : "15rem",
              minWidth: mobileCard ? "auto" : "10rem"
            }}
          >
            {translate("accept")}
          </Button>
        </div>
      )}
    </>
  ) : null;
};

UnconfirmedAppointmentActions.propTypes = {
  chat_id: PropTypes.string,
  accepted: PropTypes.bool
};

export default UnconfirmedAppointmentActions;
